import { state } from './state.js';
import { socket } from './socket.js';
import { popToast } from '../utils/alerts.js';
import { t } from './i18n.js';

let _phraseRetroValeur = null;
let qrSocketChannel = null;
let _qrR = null;

// --- FONCTIONS LOGIQUES E2EE ---

export async function demarrerE2EE(data) {
    try {
        if (!data.e2ee_enabled) {
            window.ChaosOnboarding.setSocket(socket);
            await window.ChaosOnboarding.lancer(data.pseudo);
            return;
        }
        const deviceId = await window.ChaosKeystore.getMeta('device_id');
        if (!deviceId) {
            afficherBandeauRestauration();
        } else {
            const localOk = await verifierLocalPickleValide();
            if (!localOk) {
                console.warn('[E2EE] local_pickle invalide ou désynchronisé — réparation requise.');
                declencherReparationLocale();
                return;
            }
            socket.emit('e2ee-register-device-id', { device_id: deviceId });
            activerUIE2EE();
            if (window.ChaosSessionBackup) {
                window.ChaosSessionBackup.restaurer(socket).catch(() => {});
            }
            if (window.ChaosMPCrypto) {
                window.ChaosMPCrypto.completerOTKs(socket).catch(() => {});
            }
            verifierSBKAJour();
            const sbkExistante = await window.ChaosKeystore.getMeta('session_backup_key');
            if (!sbkExistante) {
                demanderPINpourSBK();
            } else {
                assurerPhraseDeSecours().catch(() => {});
            }
        }
    } catch (err) {
        console.error('[E2EE] Erreur demarrerE2EE :', err);
    }
}

export function activerUIE2EE() {
    const section = document.getElementById('e2ee-settings-section');
    const disabled = document.getElementById('e2ee-settings-disabled');
    if (section) section.style.display = 'block';
    if (disabled) disabled.style.display = 'none';
}

export async function verifierLocalPickleValide() {
    const localPickle = await window.ChaosKeystore.getMeta('local_pickle');
    const localPickleKey = await window.ChaosKeystore.getMeta('local_pickle_key');
    if (!localPickle || !localPickleKey) return false;
    try {
        await window.ChaosOlm.init();
        const acc = window.ChaosOlm.unpickleAccount(localPickle, localPickleKey);
        acc.free();
        return true;
    } catch (_) {
        return false;
    }
}

export async function verifierSBKAJour() {
    try {
        const sbk = await window.ChaosKeystore.getMeta('session_backup_key');
        if (!sbk) return;
        const localSalt = await window.ChaosKeystore.getMeta('sbk_salt');

        const serverBackup = await new Promise(resolve => {
            socket.emit('e2ee-get-pin-backup');
            socket.once('e2ee-pin-backup', resolve);
            setTimeout(() => resolve(null), 4000);
        });
        if (!serverBackup?.pin_salt) return;

        if (!localSalt || localSalt !== serverBackup.pin_salt) {
            console.warn('[E2EE] SBK locale désynchronisée du pin_salt serveur — re-dérivation requise.');
            const modal = document.getElementById('modal-e2ee-pin-sbk');
            if (modal) {
                modal.querySelector('h2').textContent = '🔄 Synchronisation des clés';
                modal.querySelector('p').innerHTML =
                    'Tes clés de backup ne sont plus alignées avec le serveur (changement de PIN sur un autre device, ou compte ancien).<br>' +
                    'Entre ton <strong>code PIN</strong> pour les régénérer.<br>' +
                    '<span style="color:#8b949e;font-size:0.88em;">Cela débloquera l\'accès aux messages venant de tes autres appareils.</span>';
            }
            demanderPINpourSBK();
        }
    } catch (e) {
        console.error('[E2EE] Erreur vérif SBK à jour :', e.message);
    }
}

export function declencherReparationLocale() {
    const modal = document.getElementById('modal-e2ee-pin-sbk');
    if (!modal) return;
    modal.querySelector('h2').textContent = '🛠️ Réparation des clés E2EE';
    modal.querySelector('p').innerHTML =
        'Tes clés locales sont corrompues ou incomplètes. Entre ton <strong>code PIN</strong> pour les régénérer depuis la sauvegarde serveur.<br>' +
        '<span style="color:#8b949e;font-size:0.88em;">Ton identity et tes sessions restent intactes.</span>';
    window._needLocalPickleRebuild = true;
    demanderPINpourSBK();
}

export function ouvrirModaleMesDevicesE2EE() {
    document.getElementById('modal-mes-devices-e2ee').style.display = 'flex';
    document.getElementById('mes-devices-e2ee-msg').textContent = '';
    document.getElementById('mes-devices-e2ee-list').innerHTML =
        '<p style="color:#8b949e; font-style:italic;">Chargement…</p>';
    socket.emit('e2ee-list-mes-devices');
}

export function revoquerDeviceE2EE(deviceId, deviceName) {
    if (!confirm(`Révoquer l'appareil "${deviceName || deviceId.slice(0,8)+'…'}" ?\n\nIl ne pourra plus déchiffrer les nouveaux messages.`)) return;
    const msg = document.getElementById('mes-devices-e2ee-msg');
    if (msg) { msg.style.color = '#8b949e'; msg.textContent = 'Révocation en cours…'; }
    socket.emit('e2ee-revoquer-device', { device_id: deviceId });
}

export async function resetCompletE2EE() {
    const ok = confirm(
        "⚠️ Réinitialisation complète E2EE\n\n" +
        "Ça va supprimer toutes tes clés locales et le cache des messages déchiffrés.\n" +
        "Tu seras invité à entrer ton PIN au rechargement pour ré-enregistrer cet appareil.\n\n" +
        "L'historique chiffré côté serveur reste intact.\n\n" +
        "Continuer ?"
    );
    if (!ok) return;
    try {
        await window.ChaosKeystore.deleteAll();
        location.reload();
    } catch (e) {
        alert("Erreur lors de la purge : " + e.message);
    }
}

export async function abandonnerIdentiteE2EE() {
    const ok = confirm(
        "⚠️ ABANDON DÉFINITIF DE L'IDENTITÉ E2EE\n\n" +
        "À n'utiliser QUE si tu as perdu À LA FOIS ton PIN ET ta phrase de secours.\n\n" +
        "Conséquence IRRÉVERSIBLE : tous tes anciens messages privés chiffrés deviennent illisibles à vie.\n\n" +
        "Continuer ?"
    );
    if (!ok) return;
    try {
        await new Promise((resolve, reject) => {
            socket.emit('e2ee-abandonner-identite');
            socket.once('e2ee-identite-abandonnee', resolve);
            socket.once('e2ee-identite-abandonnee-erreur', () => reject(new Error('Échec serveur')));
            setTimeout(() => reject(new Error('Timeout serveur')), 8000);
        });
        await window.ChaosKeystore.deleteAll();
        location.reload();
    } catch (e) {
        alert("Échec de l'abandon : " + e.message);
    }
}

export function afficherBandeauRestauration() {
    document.getElementById('modal-e2ee-pin-sbk').querySelector('h2').textContent = '🔑 Nouvel appareil détecté';
    document.getElementById('modal-e2ee-pin-sbk').querySelector('p').innerHTML =
        'Nouvel appareil : restaure ton chiffrement.<br>' +
        '<span style="color:#8b949e;font-size:0.88em;">Le plus simple : depuis un appareil <strong>déjà connecté</strong>, ' +
        '⚙️ Paramètres → « Ajouter un appareil », puis scanne ci-dessous.</span>';
    demanderPINpourSBK();
}

export function demanderPINpourSBK() {
    document.getElementById('modal-e2ee-pin-sbk').style.display = 'flex';
    setTimeout(() => document.getElementById('sbk-pin-input')?.focus(), 80);
}

export function fermerModalPINSBK() {
    document.getElementById('modal-e2ee-pin-sbk').style.display = 'none';
    document.getElementById('sbk-pin-input').value = '';
    document.getElementById('sbk-pin-erreur').textContent = '';
}

export async function finaliserNouveauDeviceDepuisAccount(account, via) {
    const identity = JSON.parse(account.identity_keys());
    const newDeviceId = window.ChaosRecovery.nouveauDeviceId();
    const deviceName = window.ChaosRecovery.detecterNomDevice();
    const localKey = window.ChaosOlm.bytesToPickleKey(crypto.getRandomValues(new Uint8Array(32)));
    const localPickle = window.ChaosOlm.pickleAccount(account, localKey);
    const prekeySignature = account.sign(identity.curve25519);
    account.generate_one_time_keys(50);
    const otks = JSON.parse(account.one_time_keys()).curve25519 || {};
    const oneTimeKeys = Object.entries(otks).map(([k, v]) => ({ key_id: k, pubkey: v }));
    account.mark_keys_as_published();
    account.free();

    await window.ChaosKeystore.setMeta('device_id', newDeviceId);
    await window.ChaosKeystore.setMeta('device_name', deviceName);
    await window.ChaosKeystore.setMeta('local_pickle', localPickle);
    await window.ChaosKeystore.setMeta('local_pickle_key', localKey);
    await window.ChaosKeystore.setMeta('identity_pubkey', identity.curve25519);

    await new Promise((resolve, reject) => {
        socket.emit('e2ee-restaurer-device', {
            device_id: newDeviceId, device_name: deviceName,
            identity_pubkey: identity.curve25519,
            identity_ed25519: identity.ed25519,
            signed_prekey: identity.curve25519,
            prekey_signature: prekeySignature,
            one_time_keys: oneTimeKeys,
            via: via || null
        });
        socket.once('e2ee-restauration-success', resolve);
        setTimeout(() => reject(new Error('Timeout enregistrement device')), 8000);
    });

    socket.emit('e2ee-register-device-id', { device_id: newDeviceId });
    activerUIE2EE();
}

export async function validerPINpourSBK() {
    const pin = document.getElementById('sbk-pin-input').value;
    const errEl = document.getElementById('sbk-pin-erreur');
    const btn = document.getElementById('sbk-pin-btn');

    if (pin.length < 8) { errEl.textContent = 'Le PIN doit faire au moins 8 caractères.'; return; }
    errEl.textContent = ''; btn.disabled = true; btn.textContent = 'Vérification…';

    try {
        const backup = await new Promise((resolve, reject) => {
            socket.emit('e2ee-get-pin-backup');
            socket.once('e2ee-pin-backup', resolve);
            setTimeout(() => reject(new Error('Timeout serveur')), 8000);
        });

        if (!backup?.pin_salt || !backup?.encrypted_blob) {
            errEl.textContent = 'Impossible de récupérer le backup serveur.';
            btn.disabled = false; btn.textContent = 'Déverrouiller';
            return;
        }

        const pinSaltBytes = window.ChaosRecovery.b64ToBytes(backup.pin_salt);
        const clePinBytes = await window.ChaosRecovery.derivePIN(pin, pinSaltBytes);
        const clePinStr = window.ChaosOlm.bytesToPickleKey(clePinBytes);

        let account = null;
        try {
            await window.ChaosOlm.init();
            account = window.ChaosOlm.unpickleAccount(backup.encrypted_blob, clePinStr);
        } catch (_) {
            errEl.textContent = 'PIN incorrect. Réessaie.';
            btn.disabled = false; btn.textContent = 'Déverrouiller';
            return;
        }

        const existingDeviceId = await window.ChaosKeystore.getMeta('device_id');
        const needsRebuild = !!window._needLocalPickleRebuild;
        delete window._needLocalPickleRebuild;
        let isRepair = false;

        if (!existingDeviceId) {
            btn.textContent = 'Enregistrement…';
            await finaliserNouveauDeviceDepuisAccount(account);
            account = null;
        } else if (needsRebuild) {
            isRepair = true;
            btn.textContent = 'Réparation…';
            const identity = JSON.parse(account.identity_keys());
            const localKey = window.ChaosOlm.bytesToPickleKey(crypto.getRandomValues(new Uint8Array(32)));
            const localPickle = window.ChaosOlm.pickleAccount(account, localKey);
            account.free(); account = null;

            await window.ChaosKeystore.setMeta('local_pickle', localPickle);
            await window.ChaosKeystore.setMeta('local_pickle_key', localKey);
            await window.ChaosKeystore.setMeta('identity_pubkey', identity.curve25519);
            await window.ChaosKeystore.clearAllSessions();
            if (window.ChaosMPCrypto) window.ChaosMPCrypto.viderCachePair();
            socket.emit('e2ee-session-backup-clear');

            const verif = await verifierLocalPickleValide();
            if (!verif) {
                errEl.textContent = 'La réparation n\'a pas tenu. Utilise "Tout réinitialiser".';
                btn.disabled = false; btn.textContent = 'Déverrouiller';
                return;
            }
            socket.emit('e2ee-register-device-id', { device_id: existingDeviceId });
            activerUIE2EE();
        } else {
            account.free();
        }

        const sbk = await window.ChaosSessionBackup.deriverSBK(clePinBytes);
        await window.ChaosKeystore.setMeta('session_backup_key', sbk);
        await window.ChaosKeystore.setMeta('sbk_salt', backup.pin_salt);

        fermerModalPINSBK();
        const n = isRepair ? 0 : await window.ChaosSessionBackup.restaurer(socket);

        // Répare rétroactivement les backups SBK des messages envoyés sans SBK (fire-and-forget).
        if (!isRepair && window.ChaosSessionBackup) {
            window.ChaosSessionBackup.reparerBackupsManquants(socket).then(repaired => {
                // Si une conv MP est ouverte, rafraîchir l'historique pour remplacer les placeholders.
                if (state.destinataireID) {
                    // Petit délai pour laisser les backups arriver sur le serveur avant le pull.
                    setTimeout(() => socket.emit('get-private-history', { avec: state.destinataireID }), 500);
                }
            }).catch(() => {});
        }

        const isNewDevice = !existingDeviceId;
        const tBox = document.createElement('div');
        tBox.style.cssText = 'position:fixed;bottom:24px;right:24px;background:#161b22;border:1px solid #3fb950;color:#3fb950;padding:12px 20px;border-radius:8px;z-index:99999;font-size:0.88em;text-align:center;cursor:pointer;';
        tBox.innerHTML = n > 0
            ? `✅ ${n} session(s) restaurée(s) !<br><span style="font-size:0.9em;opacity:.8;">Recharge la page pour voir l'historique complet.</span>`
            : isNewDevice
                ? `✅ Appareil enregistré et chiffrement activé.`
                : isRepair
                    ? `✅ Clés locales réparées. Tu peux écrire à nouveau.`
                    : `✅ Clé de backup activée.`;
        tBox.onclick = () => { tBox.remove(); if (n > 0) location.reload(); };
        document.body.appendChild(tBox);
        setTimeout(() => tBox.remove(), 8000);

    } catch (err) {
        errEl.textContent = `Erreur : ${err.message}`;
        btn.disabled = false; btn.textContent = 'Déverrouiller';
    }
}

export function ouvrirRecuperationPhrase() {
    document.getElementById('modal-e2ee-pin-sbk').style.display = 'none';
    document.getElementById('recovery-phrase-input').value = '';
    document.getElementById('recovery-newpin').value = '';
    document.getElementById('recovery-newpin-confirm').value = '';
    document.getElementById('recovery-erreur').textContent = '';
    document.getElementById('modal-e2ee-recovery').style.display = 'flex';
    setTimeout(() => document.getElementById('recovery-phrase-input')?.focus(), 80);
}

export async function validerRecuperationPhrase() {
    const errEl = document.getElementById('recovery-erreur');
    const btn = document.getElementById('recovery-btn');
    const phrase = document.getElementById('recovery-phrase-input').value.trim().toLowerCase().replace(/\s+/g, ' ');
    const newPin = document.getElementById('recovery-newpin').value;
    const newPinConf = document.getElementById('recovery-newpin-confirm').value;

    if (phrase.split(' ').length !== 12) { errEl.textContent = 'La phrase doit contenir 12 mots.'; return; }
    if (newPin.length < 8) { errEl.textContent = 'Le PIN doit faire 8 caractères min.'; return; }
    if (newPin !== newPinConf) { errEl.textContent = 'Les deux PINs ne correspondent pas.'; return; }

    errEl.textContent = ''; btn.disabled = true; btn.textContent = 'Vérification…';

    try {
        if (!window.ChaosBIP39 || !await window.ChaosBIP39.validateMnemonic(phrase, 'en')) {
            errEl.textContent = 'Phrase de secours originale invalide.';
            btn.disabled = false; btn.textContent = 'Récupérer';
            return;
        }

        const resp = await new Promise((resolve, reject) => {
            socket.emit('e2ee-get-recovery-blob');
            socket.once('e2ee-recovery-blob', resolve);
            setTimeout(() => reject(new Error('Timeout serveur')), 8000);
        });
        if (!resp?.recovery_blob) {
            errEl.textContent = "Aucune phrase de secours enregistrée.";
            btn.disabled = false; btn.textContent = 'Récupérer';
            return;
        }

        await window.ChaosOlm.init();
        const cleBipBytes = await window.ChaosRecovery.deriveBIP39(phrase);
        const cleBipStr = window.ChaosOlm.bytesToPickleKey(cleBipBytes);
        let account = null;
        try {
            account = window.ChaosOlm.unpickleAccount(resp.recovery_blob, cleBipStr);
        } catch (_) {
            errEl.textContent = 'Phrase incorrecte.';
            btn.disabled = false; btn.textContent = 'Récupérer';
            return;
        }

        btn.textContent = 'Restauration…';
        const identity = JSON.parse(account.identity_keys());
        const newDeviceId = window.ChaosRecovery.nouveauDeviceId();
        const deviceName = window.ChaosRecovery.detecterNomDevice();
        const localKey = window.ChaosOlm.bytesToPickleKey(crypto.getRandomValues(new Uint8Array(32)));
        const localPickle = window.ChaosOlm.pickleAccount(account, localKey);
        const prekeySignature = account.sign(identity.curve25519);
        account.generate_one_time_keys(50);
        const otks = JSON.parse(account.one_time_keys()).curve25519 || {};
        const oneTimeKeys = Object.entries(otks).map(([k, v]) => ({ key_id: k, pubkey: v }));
        account.mark_keys_as_published();

        const pinSalt = window.ChaosRecovery.nouveauSel();
        const clePinBytes = await window.ChaosRecovery.derivePIN(newPin, pinSalt);
        const clePinStr = window.ChaosOlm.bytesToPickleKey(clePinBytes);
        const pinBlob = window.ChaosOlm.pickleAccount(account, clePinStr);
        const sbk = await window.ChaosSessionBackup.deriverSBK(clePinBytes);
        account.free(); account = null;

        await window.ChaosKeystore.setMeta('device_id', newDeviceId);
        await window.ChaosKeystore.setMeta('device_name', deviceName);
        await window.ChaosKeystore.setMeta('local_pickle', localPickle);
        await window.ChaosKeystore.setMeta('local_pickle_key', localKey);
        await window.ChaosKeystore.setMeta('identity_pubkey', identity.curve25519);
        await window.ChaosKeystore.setMeta('session_backup_key', sbk);
        await window.ChaosKeystore.setMeta('sbk_salt', window.ChaosRecovery.bytesToB64(pinSalt));

        await new Promise((resolve, reject) => {
            socket.emit('e2ee-restaurer-device', {
                device_id: newDeviceId, device_name: deviceName,
                identity_pubkey: identity.curve25519, identity_ed25519: identity.ed25519,
                signed_prekey: identity.curve25519, prekey_signature: prekeySignature, one_time_keys: oneTimeKeys
            });
            socket.once('e2ee-restauration-success', resolve);
            setTimeout(() => reject(new Error('Timeout')), 8000);
        });
        socket.emit('e2ee-register-device-id', { device_id: newDeviceId });

        await new Promise((resolve, reject) => {
            socket.emit('e2ee-maj-pin-backup', { pin_salt: window.ChaosRecovery.bytesToB64(pinSalt), pin_blob: pinBlob });
            socket.once('e2ee-maj-pin-success', resolve);
            setTimeout(() => reject(new Error('Timeout PIN')), 8000);
        });

        activerUIE2EE();
        document.getElementById('modal-e2ee-recovery').style.display = 'none';
        
        const n = await window.ChaosSessionBackup.restaurer(socket).catch(() => 0);
        const toast = document.createElement('div');
        toast.style.cssText = 'position:fixed;bottom:24px;right:24px;background:#161b22;border:1px solid #3fb950;color:#3fb950;padding:12px 20px;border-radius:8px;z-index:99999;font-size:0.88em;text-align:center;cursor:pointer;';
        toast.innerHTML = `✅ Accès récupéré et nouveau PIN défini !<br><span style="font-size:0.9em;opacity:.8;">Recharge la page pour voir tout ton historique.</span>`;
        toast.onclick = () => location.reload();
        document.body.appendChild(toast);
        setTimeout(() => { try { toast.remove(); } catch (_) {} }, 10000);

    } catch (err) {
        console.error('[E2EE] Échec récupération BIP39 :', err);
        errEl.textContent = `Erreur : ${err.message}`;
        btn.disabled = false; btn.textContent = 'Récupérer mon accès';
    }
}

export async function assurerPhraseDeSecours() {
    if (await window.ChaosKeystore.getMeta('recovery_blob_ok')) return;
    if (!window.ChaosBIP39 || !window.ChaosRecovery) return;
    const dejaOuvert = ['modal-e2ee-pin-sbk', 'modal-e2ee-recovery', 'modal-e2ee-onboarding']
        .some(id => { const el = document.getElementById(id); return el && el.style.display !== 'none' && el.style.display !== ''; });
    if (dejaOuvert) return;

    const resp = await new Promise((resolve) => {
        socket.emit('e2ee-get-recovery-blob');
        socket.once('e2ee-recovery-blob', resolve);
        setTimeout(() => resolve(null), 6000);
    });
    if (resp === null || resp.recovery_blob) {
        if (resp?.recovery_blob) await window.ChaosKeystore.setMeta('recovery_blob_ok', true);
        return;
    }

    const localPickle = await window.ChaosKeystore.getMeta('local_pickle');
    const localPickleKey = await window.ChaosKeystore.getMeta('local_pickle_key');
    if (!localPickle || !localPickleKey) return;

    await window.ChaosOlm.init();
    let account;
    try { account = window.ChaosOlm.unpickleAccount(localPickle, localPickleKey); } catch (_) { return; }

    try {
        const phrase = await window.ChaosBIP39.generateMnemonic(128, 'en');
        const cleBipBytes = await window.ChaosRecovery.deriveBIP39(phrase);
        const cleBipStr = window.ChaosOlm.bytesToPickleKey(cleBipBytes);
        const recoveryBlob = window.ChaosOlm.pickleAccount(account, cleBipStr);

        const ok = await new Promise((resolve) => {
            socket.emit('e2ee-set-recovery-blob', { recovery_blob: recoveryBlob });
            socket.once('e2ee-set-recovery-blob-ok', () => resolve(true));
            setTimeout(() => resolve(false), 6000);
        });
        if (!ok) return;

        window._phraseRetroValeur = phrase;
        const cont = document.getElementById('e2ee-phrase-retro-mots');
        cont.innerHTML = '';
        phrase.split(' ').forEach((mot, i) => {
            const cell = document.createElement('div');
            cell.className = 'e2ee-mot';
            cell.innerHTML = `<span class="e2ee-mot-num">${i + 1}</span><span class="e2ee-mot-txt">${mot}</span>`;
            cont.appendChild(cell);
        });
        const chk = document.getElementById('e2ee-phrase-retro-confirme');
        if (chk) chk.checked = false;
        document.getElementById('e2ee-phrase-retro-erreur').textContent = '';
        document.getElementById('modal-e2ee-phrase-retro').style.display = 'flex';
        const cpBtn = document.getElementById('e2ee-phrase-retro-copier');
        if (cpBtn) cpBtn.onclick = () => {
            navigator.clipboard.writeText(_phraseRetroValeur || '').then(() => {
                const a = cpBtn.textContent; cpBtn.textContent = '✓ Copié !';
                setTimeout(() => { cpBtn.textContent = a; }, 2000);
            }).catch(() => {});
        };
    } finally {
        try { account.free(); } catch (_) {}
    }
}

export async function confirmerPhraseRetro() {
    const chk = document.getElementById('e2ee-phrase-retro-confirme');
    const err = document.getElementById('e2ee-phrase-retro-erreur');
    if (!chk || !chk.checked) {
        if (err) err.textContent = 'Coche la case pour confirmer que tu as noté ta phrase.';
        return;
    }
    window._phraseRetroValeur = null;
    await window.ChaosKeystore.setMeta('recovery_blob_ok', true);
    document.getElementById('modal-e2ee-phrase-retro').style.display = 'none';
}

export function majIndicateurE2EE(pseudo) {
    const header = document.getElementById('chat-header');
    if (!header) return;
    header.querySelectorAll('.e2ee-badge').forEach(b => b.remove());
    if (!pseudo) return;

    window.ChaosKeystore.getMeta('device_id').then(myDeviceId => {
        if (!myDeviceId) return;
        const badge = document.createElement('span');
        badge.className = 'e2ee-badge';
        badge.title = 'Conversation chiffrée de bout en bout';
        badge.style.cssText = 'margin-left:8px;font-size:0.85em;color:#3fb950;cursor:default;';
        badge.textContent = '🔒';
        header.appendChild(badge);
    }).catch(() => {});
}

// --- LOGIQUE FINALE D'APPAIRAGE QR GÉANT ---

export async function ouvrirModaleAppairage() {
    document.getElementById('modal-e2ee-qr').style.display = 'flex';
    const container = document.getElementById('e2ee-qr-container');
    const statut = document.getElementById('e2ee-qr-statut');
    const verif = document.getElementById('e2ee-qr-verif');
    verif.style.display = 'none';
    container.innerHTML = '<div class="e2ee-spinner"></div>';
    statut.textContent = 'Génération du code QR…';

    const sbk = await window.ChaosKeystore.getMeta('session_backup_key');
    if (!sbk) {
        statut.textContent = "Cet appareil n'a pas encore ta clé E2EE déverrouillée — impossible de la transférer.";
        container.innerHTML = '';
        return;
    }
    const sbkSalt = await window.ChaosKeystore.getMeta('sbk_salt');

    const challenge = window.ChaosRecovery.nouveauDeviceId();
    const eph = await window.ChaosQRPair.genEphemere();
    const payload = JSON.stringify({ v: 1, pseudo: state.monPseudo, challenge, ek: eph.pubB64 });

    if (!window.QRCode) {
        await new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = '/crypto/vendor/qrcode.min.js';
            s.onload = resolve; s.onerror = reject;
            document.head.appendChild(s);
        });
    }
    const canvas = document.createElement('canvas');
    container.innerHTML = '';
    container.appendChild(canvas);
    QRCode.toCanvas(canvas, payload, { width: 220, color: { dark: '#c9d1d9', light: '#0d1117' } });
    document.getElementById('e2ee-qr-code-texte').value = btoa(payload);
    statut.textContent = 'Scanne ce QR depuis ton nouvel appareil. Expire dans 5 min.';

    socket.off('e2ee-appairage-demande');
    socket.on('e2ee-appairage-demande', async (data) => {
        if (!data || data.challenge !== challenge || !data.ephPub) return;
        let canal;
        try {
            canal = await window.ChaosQRPair.deriverCanal(eph.priv, data.ephPub, challenge);
        } catch (e) {
            statut.textContent = 'Échec du canal sécurisé. Réessaie.';
            return;
        }
        document.getElementById('e2ee-qr-verif-device').textContent = '« ' + (data.device_name || 'Un appareil') + ' »';
        document.getElementById('e2ee-qr-verif-code').textContent = canal.code;
        verif.style.display = 'block';
        statut.textContent = 'Appareil détecté — vérifie le code ci-dessous.';

        const btnOk = document.getElementById('e2ee-qr-autoriser');
        const btnNo = document.getElementById('e2ee-qr-refuser');
        const cleanup = () => { btnOk.onclick = null; btnNo.onclick = null; };
        btnNo.onclick = () => { cleanup(); verif.style.display = 'none'; statut.textContent = 'Transfert refusé.'; };
        btnOk.onclick = async () => {
            cleanup();
            btnOk.disabled = true;
            try {
                const lp = await window.ChaosKeystore.getMeta('local_pickle');
                const lpk = await window.ChaosKeystore.getMeta('local_pickle_key');
                await window.ChaosOlm.init();
                const acc = window.ChaosOlm.unpickleAccount(lp, lpk);
                const transferKey = window.ChaosOlm.bytesToPickleKey(crypto.getRandomValues(new Uint8Array(32)));
                const accountPickle = window.ChaosOlm.pickleAccount(acc, transferKey);
                acc.free();
                const encBlob = await window.ChaosQRPair.chiffrer(canal.aesKey, {
                    accountPickle, accountKey: transferKey,
                    sbk, sbk_salt: sbkSalt || null
                });
                socket.emit('e2ee-appairage-reponse', { challenge, encBlob });
                verif.style.display = 'none';
                statut.textContent = '✅ Clé transférée ! Ton nouvel appareil peut accéder à tes MPs.';
                setTimeout(fermerModaleQR, 3500);
            } catch (e) {
                statut.textContent = 'Échec du chiffrement du transfert.';
            }
            btnOk.disabled = false;
        };
    });
}

export function fermerModaleQR() {
    document.getElementById('modal-e2ee-qr').style.display = 'none';
    document.getElementById('e2ee-qr-verif').style.display = 'none';
    socket.off('e2ee-appairage-demande');
}

export async function ouvrirRestaurationQR() {
    if (!window.ChaosQRPair) { popToast('Module QR indisponible.', 'error'); return; }
    document.getElementById('modal-e2ee-qr-restore').style.display = 'flex';
    const statut = document.getElementById('qr-restore-statut');
    document.getElementById('qr-restore-verif').style.display = 'none';
    document.getElementById('qr-restore-paste').value = '';
    statut.textContent = 'Initialisation du canal sécurisé…';
    _qrR = { eph: await window.ChaosQRPair.genEphemere(), challenge: null, aesKey: null, camStream: null, camInt: null, done: false, pinWasOpen: false };

    const _pinM = document.getElementById('modal-e2ee-pin-sbk');
    if (_pinM && _pinM.style.display !== 'none') { _qrR.pinWasOpen = true; _pinM.style.display = 'none'; }

    socket.off('e2ee-appairage-aucun-device');
    socket.on('e2ee-appairage-aucun-device', () => {
        if (_qrR && !_qrR.done) statut.textContent = '⚠️ Aucun appareil de confiance en ligne. Connecte un autre appareil ou utilise ton PIN.';
    });
    socket.off('e2ee-appairage-reponse');
    socket.on('e2ee-appairage-reponse', _qrRestoreReponse);

    if ('BarcodeDetector' in window) {
        try {
            const det = new BarcodeDetector({ formats: ['qr_code'] });
            const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
            const video = document.getElementById('qr-restore-video');
            video.srcObject = stream; video.style.display = 'block';
            await video.play();
            _qrR.camStream = stream;
            statut.textContent = 'Vise le QR de l\'autre appareil…';
            _qrR.camInt = setInterval(async () => {
                if (!_qrR || _qrR.done) return;
                try {
                    const codes = await det.detect(video);
                    if (codes && codes[0] && codes[0].rawValue) _qrRestoreAvecPayload(codes[0].rawValue);
                } catch (_) {}
            }, 400);
        } catch (_) {
            statut.textContent = 'Caméra indisponible — utilise « Coller le code ».';
        }
    } else {
        statut.textContent = 'Scanner indisponible sur ce navigateur — utilise « Coller le code ».';
    }
}

export function qrRestoreDepuisTexte() {
    const v = document.getElementById('qr-restore-paste').value.trim();
    if (v) _qrRestoreAvecPayload(v);
}

export async function _qrRestoreAvecPayload(str) {
    if (!_qrR || _qrR.done || _qrR.challenge) return;
    let obj;
    try {
        let decoded = str;
        if (!str.startsWith('{')) { try { decoded = atob(str); } catch (_) {} }
        obj = JSON.parse(decoded);
    } catch (_) { document.getElementById('qr-restore-statut').textContent = 'Code illisible.'; return; }
    if (!obj || obj.v !== 1 || !obj.ek || !obj.challenge) {
        document.getElementById('qr-restore-statut').textContent = 'Code invalide.'; return;
    }
    if (obj.pseudo && state.monPseudo && obj.pseudo !== state.monPseudo) {
        document.getElementById('qr-restore-statut').textContent = '⚠️ Ce QR appartient à un autre compte.'; return;
    }
    _qrStopCam();
    let canal;
    try { canal = await window.ChaosQRPair.deriverCanal(_qrR.eph.priv, obj.ek, obj.challenge); }
    catch (e) { document.getElementById('qr-restore-statut').textContent = 'Échec du canal sécurisé.'; return; }
    _qrR.challenge = obj.challenge;
    _qrR.aesKey = canal.aesKey;
    document.getElementById('qr-restore-code').textContent = canal.code;
    document.getElementById('qr-restore-verif').style.display = 'block';
    document.getElementById('qr-restore-statut').textContent = 'En attente de ta validation sur l\'autre appareil…';
    socket.emit('e2ee-appairage-demande', {
        challenge: obj.challenge,
        ephPub: _qrR.eph.pubB64,
        device_name: window.ChaosRecovery.detecterNomDevice(),
        // Pseudo cible (issu du QR) : indispensable car ce nouvel appareil n'est
        // pas encore connecté → le serveur ne peut pas déduire le compte.
        pseudo: obj.pseudo || state.monPseudo || null
    });
}

export async function _qrRestoreReponse({ challenge, encBlob } = {}) {
    if (!_qrR || _qrR.done || !_qrR.aesKey || challenge !== _qrR.challenge || !encBlob) return;
    _qrR.done = true;
    const statut = document.getElementById('qr-restore-statut');
    statut.textContent = 'Réception de ta clé… enregistrement de cet appareil…';
    try {
        const data = await window.ChaosQRPair.dechiffrer(_qrR.aesKey, encBlob);
        if (!data || !data.accountPickle || !data.accountKey || !data.sbk) throw new Error('Transfert incomplet');
        await window.ChaosOlm.init();
        const account = window.ChaosOlm.unpickleAccount(data.accountPickle, data.accountKey);
        await finaliserNouveauDeviceDepuisAccount(account, 'qr');
        await window.ChaosKeystore.setMeta('session_backup_key', data.sbk);
        if (data.sbk_salt) await window.ChaosKeystore.setMeta('sbk_salt', data.sbk_salt);

        fermerRestaurationQR();
        fermerModalPINSBK();
        const n = await window.ChaosSessionBackup.restaurer(socket).catch(() => 0);
        const tBox = document.createElement('div');
        tBox.style.cssText = 'position:fixed;bottom:24px;right:24px;background:#161b22;border:1px solid #3fb950;color:#3fb950;padding:12px 20px;border-radius:8px;z-index:99999;font-size:0.88em;text-align:center;cursor:pointer;';
        tBox.innerHTML = `✅ Appareil restauré via QR !<br><span style="font-size:0.9em;opacity:.8;">Recharge la page pour voir tout l'historique.</span>`;
        tBox.onclick = () => location.reload();
        document.body.appendChild(tBox);
        setTimeout(() => { try { tBox.remove(); } catch (_) {} }, 9000);
    } catch (e) {
        _qrR.done = false;
        statut.textContent = 'Échec : ' + (e.message || 'transfert invalide') + '. Réessaie ou utilise le PIN.';
    }
}

export function _qrStopCam() {
    if (!_qrR) return;
    if (_qrR.camInt) { clearInterval(_qrR.camInt); _qrR.camInt = null; }
    if (_qrR.camStream) { try { _qrR.camStream.getTracks().forEach(t => t.stop()); } catch (_) {} _qrR.camStream = null; }
    const v = document.getElementById('qr-restore-video');
    if (v) { v.srcObject = null; v.style.display = 'none'; }
}

export function fermerRestaurationQR() {
    _qrStopCam();
    socket.off('e2ee-appairage-reponse');
    socket.off('e2ee-appairage-aucun-device');
    const reouvrirPin = !!(_qrR && _qrR.pinWasOpen);
    _qrR = null;
    const m = document.getElementById('modal-e2ee-qr-restore');
    if (m) m.style.display = 'none';
    if (reouvrirPin) {
        const pm = document.getElementById('modal-e2ee-pin-sbk');
        if (pm) pm.style.display = 'flex';
    }
}

export async function ouvrirModaleChangerPIN() {
    const localPickle = await window.ChaosKeystore.getMeta('local_pickle');
    const localPickleKey = await window.ChaosKeystore.getMeta('local_pickle_key');
    let identiteOk = false;
    if (localPickle && localPickleKey) {
        try { await window.ChaosOlm.init(); const a = window.ChaosOlm.unpickleAccount(localPickle, localPickleKey); a.free(); identiteOk = true; } catch (_) {}
    }
    if (!identiteOk) {
        const allerRecup = confirm(
            "Changer le PIN nécessite une identité E2EE déverrouillée sur cet appareil.\n\n" +
            "Tu as oublié ton PIN ? Utilise la récupération par phrase de secours (12 mots).\n\n" +
            "Ouvrir la récupération maintenant ?"
        );
        if (allerRecup) ouvrirRecuperationPhrase();
        return;
    }
    document.getElementById('changer-pin-msg').textContent = '';
    document.getElementById('modal-e2ee-changer-pin').style.display = 'flex';
}

export async function validerChangementPIN() {
    const p1 = document.getElementById('new-pin-input').value;
    const p2 = document.getElementById('new-pin-confirm').value;
    const msg = document.getElementById('changer-pin-msg');

    if (p1.length < 8) { msg.style.color = '#f85149'; msg.textContent = 'PIN trop court (8+ caractères requis).'; return; }
    if (p1 !== p2) { msg.style.color = '#f85149'; msg.textContent = 'Les PINs ne correspondent pas.'; return; }

    msg.style.color = '#8b949e'; msg.textContent = 'Génération de la nouvelle sauvegarde…';
    try {
        const localPickle = await window.ChaosKeystore.getMeta('local_pickle');
        const localPickleKey = await window.ChaosKeystore.getMeta('local_pickle_key');
        const account = window.ChaosOlm.unpickleAccount(localPickle, localPickleKey);

        const newSalt = window.ChaosRecovery.nouveauSel();
        const newKey = await window.ChaosRecovery.derivePIN(p1, newSalt);
        const newBlob = window.ChaosOlm.pickleAccount(account, window.ChaosOlm.bytesToPickleKey(newKey));
        account.free();

        socket.emit('e2ee-maj-pin-backup', {
            pin_salt: window.ChaosRecovery.bytesToB64(newSalt),
            pin_blob: newBlob
        });
        socket.once('e2ee-maj-pin-success', () => {
            msg.style.color = '#3fb950';
            msg.textContent = '✅ PIN mis à jour !';
            setTimeout(() => { document.getElementById('modal-e2ee-changer-pin').style.display = 'none'; }, 2000);
        });
    } catch (e) {
        msg.style.color = '#f85149'; msg.textContent = 'Erreur : ' + e.message;
    }
}

// --- INITIALISATION DES LISTENERS ---

export function initE2EESync() {
    socket.on('e2ee-device-revoque', async () => {
        console.warn('[E2EE] Ce device a été révoqué côté serveur — nettoyage et ré-enregistrement requis.');
        try {
            await window.ChaosKeystore.deleteMeta('device_id');
            await window.ChaosKeystore.deleteMeta('device_name');
            await window.ChaosKeystore.deleteMeta('local_pickle');
            await window.ChaosKeystore.deleteMeta('local_pickle_key');
            await window.ChaosKeystore.deleteMeta('identity_pubkey');
            await window.ChaosKeystore.clearAllSessions();
            if (window.ChaosMPCrypto) window.ChaosMPCrypto.viderCachePair();
            popToast('🔄 Cet appareil a été révoqué. Entre ton PIN pour le ré-enregistrer.');
            afficherBandeauRestauration();
        } catch (e) {
            console.error('[E2EE] Erreur nettoyage post-révocation :', e.message);
        }
    });

    socket.on('e2ee-mes-devices', ({ devices, current_device_id } = {}) => {
        const list = document.getElementById('mes-devices-e2ee-list');
        if (!list) return;
        if (!Array.isArray(devices) || devices.length === 0) {
            list.innerHTML = '<p style="color:#8b949e;">Aucun appareil enregistré.</p>';
            return;
        }
        list.innerHTML = devices.map(d => {
            const isCurrent = d.device_id === current_device_id;
            const enregistre = d.date_appairage ? new Date(d.date_appairage).toLocaleString('fr-FR') : '?';
            const vu = d.derniere_activite ? new Date(d.derniere_activite).toLocaleString('fr-FR') : '?';
            return `
                <div style="border:1px solid #30363d; border-radius:6px; padding:10px; background:#0d1117;">
                    <div style="display:flex; align-items:center; justify-content:space-between; gap:10px;">
                        <div style="flex:1; min-width:0;">
                            <div style="color:#c9d1d9; font-weight:bold;">
                                ${d.device_name || 'Appareil sans nom'}
                                ${isCurrent ? '<span style="color:#3fb950; font-size:0.8em; margin-left:6px;">(cet appareil)</span>' : ''}
                            </div>
                            <div style="color:#8b949e; font-size:0.78em; margin-top:4px;">
                                ID : <code>${d.device_id.slice(0,8)}…</code> · ${d.otks_restantes} OTKs restantes
                            </div>
                            <div style="color:#6e7681; font-size:0.75em;">
                                Enregistré : ${enregistre}<br>Dernière activité : ${vu}
                            </div>
                        </div>
                        ${isCurrent ? '' : `
                            <button onclick="revoquerDeviceE2EE('${d.device_id}', '${(d.device_name || '').replace(/'/g, "\\'")}')"
                                    class="cyber-btn btn-alt"
                                    style="color:var(--theme-danger); font-size:0.82em; padding:6px 12px; flex-shrink:0;">
                                Révoquer
                            </button>
                        `}
                    </div>
                </div>
            `;
        }).join('');
    });

    socket.on('e2ee-revoquer-device-ok', ({ device_id }) => {
        const msg = document.getElementById('mes-devices-e2ee-msg');
        if (msg) {
            msg.style.color = '#3fb950';
            msg.textContent = `✅ Appareil ${device_id.slice(0,8)}… révoqué.`;
        }
        socket.emit('e2ee-list-mes-devices');
        if (window.ChaosMPCrypto) window.ChaosMPCrypto.viderCachePair();
    });

    socket.on('e2ee-revoquer-device-error', (errMsg) => {
        const msg = document.getElementById('mes-devices-e2ee-msg');
        if (msg) {
            msg.style.color = '#f85149';
            msg.textContent = '❌ ' + errMsg;
        }
    });

    socket.on('e2ee-otk-low', ({ remaining } = {}) => {
        console.warn(`[E2EE] Stock OTK bas (${remaining} restantes) — réapprovisionnement automatique.`);
        if (window.ChaosMPCrypto) {
            window.ChaosMPCrypto.completerOTKs(socket).catch(() => {});
        }
    });
}